<script setup lang="ts">
export interface TeamMemberProps {
  id: number;
}

const props = defineProps<TeamMemberProps>();

const { author: member } = useAuthor(props.id);
</script>

<template>
  <div class="flex flex-col items-center text-center bg-white/70 rounded-2xl p-6 shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:bg-white/90">
    <div class="w-28 h-28 md:w-36 md:h-36 rounded-full overflow-hidden ring-4 ring-white shadow-lg">
      <NuxtImg
        v-if="member?.value?.image"
        :src="toCmsMediaPath(member.value.image.url)"
        :alt="member?.name ?? ''"
        width="160"
        height="160"
        class="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
    <h3 class="mt-5 text-lg font-semibold text-[var(--color-charcoal)]">
      {{ member?.name }}
    </h3>
    <p
      v-if="member?.value?.title"
      class="mt-1 text-sm text-[var(--color-charcoal)]/60"
    >
      {{ member.value.title }}
    </p>
  </div>
</template>
